import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DeviceLogMessage } from 'src/app/generated/CrossPoint.RemoteXpac.Server';

export interface LogDetailsDialogData {
  log: DeviceLogMessage; 
}

@Component({
  selector: 'xpac-xpac-logging-details',
  templateUrl: './xpac-logging-details.component.html',
  styleUrls: ['./xpac-logging-details.component.scss']
})
export class XpacLoggingDetailsComponent implements OnInit {

  constructor( public dialogRef: MatDialogRef<XpacLoggingDetailsComponent>, @Inject(MAT_DIALOG_DATA) public log: LogDetailsDialogData) {}

  public ngOnInit(): void {}

  public onNoClick(): void {   
    this.dialogRef.close(true);    
  }

  public showUserData(): boolean{
    return this.log.log.user !== null;
  }

  public showImpUserData(): boolean{
    return this.log.log.impUser !== null;
  }

}
